const formData = {
  insuredresultantdamages: [false, false, false, false, false]
};

export default formData;
